import React, { useState, useEffect } from 'react';
import './../../entrydoor.css';

const SillFinish = ({ value, onChange, label = 'Finish' }) => {
    const [selectedSillFinish, setSelectedSillFinish] = useState(value || "");

    const handleSillFinishChange = (e) => {
        const newValue = e.target.value;
        setSelectedSillFinish(newValue); // Update local state
        onChange(newValue); // Call onChange prop with the new value
    };

/*    useEffect(() => {
    }, [options]);
*/

    return (
        <div className="a-container">
            <label style={{ display: "none" }} htmlFor="SillFinish">{label}</label>
            <select
                style={{ display: "none" }}
                id="SillFinish"
                value={selectedSillFinish}
                onChange={handleSillFinishChange}
            >
                <option value="" >Select an option</option>
                <option style={{ display: "none" }} value="ClearAnodized">
                    {selectedSillFinish === "ClearAnodized" ? "Clear Anodized ✔" : "Clear Anodized"}
                </option>
                <option style={{ display: "none" }} value="BlackAnodized">
                    {selectedSillFinish === "BlackAnodized" ? "Black Anodized ✔" : "Black Anodized"}
                </option>
                <option style={{ display: "none" }} value="Mill">
                    {selectedSillFinish === "Mill" ? "Mill ✔" : "Mill"}
                </option>
            </select>
        </div>
    );
};

export default SillFinish;
